<template>
  <div>
    <v-stepper v-model="careUserStepper">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="careUserStepper > 1">1. Basic Info</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="careUserStepper > 2">1. Address</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" :complete="careUserStepper > 3">2. Emergency Contact 1</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4" :complete="careUserStepper > 4">4. Emergency Contact 2</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="5" :complete="careUserStepper > 5">5. (Optional) Care Location Contact</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="6">4. Confirmation</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form v-model="valid1">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="firstName"
                  label="First Name"
                  type="text"
                  hint="Please enter your first name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="lastName"
                  label="Last Name"
                  hint="Please enter your last name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="phoneNumber"
                  label="Phone Number"
                  hint="Please enter your phone number here"
                  :counter="10"
                  maxlength="10"
                  :mask="phoneMask"
                  :rules="phoneRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="emailAddress1"
                  label="Email1"
                  hint="Please enter your email #1 here"
                  :counter="45"
                  maxlength="45"
                  :rules="emailRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="emailAddress2"
                  label="Email2"
                  hint="Please enter your email #2 here"
                  :counter="45"
                  maxlength="45"
                  :rules="emailRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn color="primary" @click.native="careUserStepper = 2" :disabled="!valid1">Continue</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-form v-model="valid2">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="unitNumber"
                  label="Unit Number"
                  type="text"
                  hint="Please enter your unit number here"
                  :counter="45"
                  maxlength="45"
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="streetAddress"
                  label="Street Address"
                  hint="Please enter your street address here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="city"
                  label="City"
                  hint="Please enter your city here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="province"
                  label="Province"
                  hint="Please enter your province here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="postalCode"
                  label="Postal Code"
                  hint="Please enter your postal code here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="careUserStepper = 1">Back</v-btn>
            <v-btn color="primary" @click.native="careUserStepper = 3" :disabled="!valid2">Continue</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-form v-model="valid3">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="emergency1firstName"
                  label="Emergency Contact 1 - First Name"
                  type="text"
                  hint="Please enter your emergency contact 1 first name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="emergency1lastName"
                  label="Emergency Contact 1 - Last Name"
                  hint="Please enter your emergency contact 1 last name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="emergency1phoneNumber"
                  label="Emergency Contact 1 - Phone Number"
                  hint="Please enter your emergency contact 1 phone number here"
                  :counter="10"
                  maxlength="10"
                  :mask="phoneMask"
                  :rules="phoneRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="emergency1emailAddress"
                  label="Emergency Contact 1 - Email"
                  hint="Please enter your emergency contact 1 email here"
                  :counter="45"
                  maxlength="45"
                  :rules="emailRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="careUserStepper = 2">Back</v-btn>
            <v-btn color="primary" @click.native="careUserStepper = 4" :disabled="!valid3">Continue</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-form v-model="valid4">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="emergency2firstName"
                  label="Emergency Contact 2 - First Name"
                  type="text"
                  hint="Please enter your emergency contact 2 first name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="emergency2lastName"
                  label="Emergency Contact 2 - Last Name"
                  hint="Please enter your emergency contact 2 last name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="emergency2phoneNumber"
                  label="Phone Number"
                  hint="Please enter your emergency contact 2 phone number here"
                  :counter="10"
                  maxlength="10"
                  :mask="phoneMask"
                  :rules="phoneRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="emergency2emailAddress"
                  label="Emergency Contact 2 - Email"
                  hint="Please enter your emergency contact 2 email here"
                  :counter="45"
                  maxlength="45"
                  :rules="emailRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="careUserStepper = 3">Back</v-btn>
            <v-btn color="primary" @click.native="careUserStepper = 5" :disabled="!valid4">Continue</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="5">
          <v-form v-model="valid5">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="locationFirstName"
                  label="(Optional) Care Location Conatct - First Name"
                  type="text"
                  hint="Please enter your care location contact first name here"
                  :counter="45"
                  maxlength="45"
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="locationLastName"
                  label="(Optional) Care Location Contact - Last Name"
                  hint="Please enter your care location contact last name here"
                  :counter="45"
                  maxlength="45"
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="locationPhoneNumber"
                  label="(Optional) Care Location Contact - Phone Number"
                  hint="Please enter your care location contact phone number here"
                  :counter="10"
                  maxlength="10"
                  :mask="phoneMask"
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="locationEmailAddress"
                  label="(Optional) Care Location Contact - Email"
                  hint="Please enter your care location email here"
                  :counter="45"
                  maxlength="45"
                  clearable
                  :rules="emailRules"
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="careUserStepper = 4">Back</v-btn>
            <v-btn color="primary" @click.native="careUserStepper = 6" :disabled="!valid5">Continue</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="6">
          <v-card color="grey lighten-4" class="mb-5"></v-card>
            <v-card-text class="text-xs-left">
              <p>First Name: {{this.firstName}} </p>
              <p>Last Name: {{this.lastName}} </p>
            </v-card-text>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="careUserStepper = 5">Back</v-btn>
            <v-btn color="primary" @click.native="create">Submit</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

  </div>
</template>
<script>
import CareUserService from '@/services/CareUserService'
  export default {
    data () {
      return {
        valid: false,
        valid1: false,
        valid2: false,
        valid3: false,
        valid4: false,
        valid5: false,

        phoneMask: 'phone',
        nameRules: [
          (v) => !!v || 'This field is required'
        ],
        phoneRules: [
          (v) => !!v || 'Phone is required',
          (v) => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || 'Phone must be 10 digits'
        ],
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        careUserStepper: 0,
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailAddress1: '',
        emailAddress2: '',
        dateOfBirth: '',
        gender: '',
        unitNumber: '',
        streetAddress: '',
        city: '',
        province: '',
        postalCode: '',
        emergency1firstName: '',
        emergency1lastName: '',
        emergency1phoneNumber: '',
        emergency1emailAddress: '',
        emergency2firstName: '',
        emergency2lastName: '',
        emergency2phoneNumber: '',
        emergency2emailAddress: '',
        locationFirstName: '',
        locationLastName: '',
        locationPhoneNumber: '',
        locationEmailAddress: '',
        error: null
      }
    },
    methods: {
      cancel() {
        this.$router.push({
          name: 'careUserList'
        })
      },
      async create() {
        try {
          const response = await CareUserService.create({
            firstName: this.firstName.trim(),
            lastName: this.lastName.trim(),
            phoneNumber: this.phoneNumber.trim(),
            unitNumber: this.unitNumber.trim(),
            streetAddress: this.streetAddress.trim(),
            city: this.city.trim().toUpperCase(),
            province: this.province.trim().toUpperCase(),
            postalCode: this.postalCode.trim().toUpperCase(),
            emailAddress1: this.emailAddress1.trim(),
            emailAddress2: this.emailAddress2.trim(),
            careGroupId: '2',
            serviceId: '3',
            emergency1firstName: this.emergency1firstName.trim(),
            emergency1lastName: this.emergency1lastName.trim(),
            emergency1phoneNumber: this.emergency1phoneNumber.trim(),
            emergency1emailAddress: this.emergency1emailAddress.trim(),
            emergency2firstName: this.emergency2firstName.trim(),
            emergency2lastName: this.emergency2lastName.trim(),
            emergency2phoneNumber: this.emergency2phoneNumber.trim(),
            emergency2emailAddress: this.emergency2emailAddress.trim(),
            locationFirstName: this.locationFirstName.trim(),
            locationLastName: this.locationLastName.trim(),
            locationPhoneNumber: this.locationPhoneNumber.trim(),
            locationEmailAddress: this.locationEmailAddress.trim()
          })
          this.error = "Create Successful"
          this.$router.push({
            name: 'careUserList'
          })
        } catch (error) {
            this.error = this.handleError(error)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/CareUser/CareUserNew.vue